const cities = [
  { name: "Strasbourg", route: "/" },
  { name: "Haguenau", route: "/haguenau" },
  { name: "Schiltigheim", route: "/schiltigheim" },
  { name: "Illkirch-Graffenstaden", route: "/illkirch-graffenstaden" },
  { name: "Sélestat", route: "/selestat" },
  { name: "Lingolsheim", route: "/lingolsheim" },
  { name: "Bischheim", route: "/bischheim" },
  { name: "Bischwiller", route: "/bischwiller" },
  { name: "Ostwald", route: "/ostwald" },
  { name: "Saverne", route: "/saverne" },
  { name: "Obernai", route: "/obernai" },
  { name: "Hœnheim", route: "/hoenheim" },
  { name: "Erstein", route: "/erstein" },
  { name: "Brumath", route: "/brumath" },
  { name: "Molsheim", route: "/molsheim" },
  { name: "Geispolsheim", route: "/geispolsheim" },
  { name: "Eckbolsheim", route: "/eckbolsheim" },
  { name: "Souffelweyersheim", route: "/souffelweyersheim" },
  { name: "Wissembourg", route: "/wissembourg" },
  { name: "Barr", route: "/barr" },
];

export default function GrilleVilles() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-brand-blue mb-3">
            Nos zones d'intervention
          </h2>
          <p className="text-brand-text text-base md:text-lg max-w-2xl mx-auto">
            Cliquez sur votre ville pour découvrir nos services de réparation et de pose de volet roulant.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {cities.map((city) => (
            <a
              key={city.name}
              href={city.route}
              className="flex flex-col items-center justify-center gap-3 bg-white border border-brand-border rounded-xl p-5 md:p-6 hover:border-brand-cyan hover:bg-brand-light transition-all group"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-map-pin-line text-2xl text-brand-cyan"></i>
              </div>
              <span className="text-brand-blue font-semibold text-sm md:text-base text-center group-hover:text-brand-cyan transition-colors">
                {city.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}